/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_DepartmentInputs */

const en__field_department = /** @type {(inputs: _Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Department`)
};

const de__field_department = /** @type {(inputs: _Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachbereich`)
};

/**
* | output |
* | --- |
* | "Department" |
*
* @param {_Field_DepartmentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_department = /** @type {((inputs?: _Field_DepartmentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_DepartmentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_department(inputs)
	return de__field_department(inputs)
});